import React from "react";
import PropTypes from "prop-types";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import Condominium from "../components/condominium/index";
import CreateCondominium from "../components/condominium/CreateCondominium";
import EditCondominium from "../components/condominium/EditCondominium";

const CondominiumRoutes = ({ match: { url } }) => (
  <Switch>
    <Route path={`${url}`} exact component={Condominium} />
    <Route path={`${url}/create`} exact component={CreateCondominium} />
    <Route path={`${url}/:id`} exact component={EditCondominium} />
    <Redirect to="/errors/404" />
  </Switch>
);

CondominiumRoutes.propTypes = { match: PropTypes.object.isRequired };

export default withRouter(CondominiumRoutes);
